var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "messenger-contact-list-page" } },
    [
      _vm.showTitle
        ? _c("h3", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("wp.contactList"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.checkboxOption.selectedRowKeys.length
        ? _c("div", { staticClass: "selection-bar" }, [
            _c(
              "section",
              { staticClass: "uncheck", on: { click: _vm.unselectAll } },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" arrow_back "),
                ]),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("chatbotv2.uncheckAll")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "select", on: { click: _vm.selectAll } },
              [_vm._v(_vm._s(_vm.$t("chatbotv2.selectAll")))]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "select", on: { click: _vm.deleteAll } },
              [_vm._v(_vm._s(_vm.$t("integration.deleteAll")))]
            ),
            _vm._v(" "),
            _c("section", { staticClass: "queries" }, [
              _vm._v(
                "\n            +" +
                  _vm._s(
                    _vm.checkboxOption.selectedRowKeys.length +
                      " " +
                      _vm.$t("wp.contactSelected")
                  ) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "actions" },
              [
                _c(
                  "a-button",
                  { staticClass: "d-none", attrs: { ghost: "", disabled: "" } },
                  [_vm._v(_vm._s(_vm.$t("wp.sendBroadcastMessage")))]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "toolbox" }, [
        _c("div", [_vm._t("left-actions")], 2),
        _vm._v(" "),
        _c("div", [_vm._t("middle-actions")], 2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _vm.channel && _vm.channel.isDeleted
              ? _c(
                  "a-dropdown",
                  [
                    _c("SupsisButton", { attrs: { xxsmall: "", icon: "" } }, [
                      _c("i", { staticClass: "material-icons text-warning" }, [
                        _vm._v("more_horiz"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-menu",
                      { attrs: { slot: "overlay" }, slot: "overlay" },
                      [
                        _c(
                          "a-menu-item",
                          {
                            key: "transfer",
                            on: {
                              click: function ($event) {
                                return _vm.showTransferModal()
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("Kişileri Başka Kanala Transfer Et"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "div",
            { staticClass: "table-pagination" },
            [
              _c("a-input-search", {
                staticClass: "row search-input",
                staticStyle: { width: "300px" },
                attrs: { placeholder: _vm.$t("message.search") },
                on: {
                  input: function ($event) {
                    return _vm.onSearch($event.target.value)
                  },
                },
                model: {
                  value: _vm.searchText,
                  callback: function ($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText",
                },
              }),
              _vm._v(" "),
              _c("ve-pagination", {
                attrs: {
                  total: _vm.pagination.total,
                  "page-index": _vm.pagination.current,
                  "page-size": _vm.pagination.defaultPageSize,
                  "page-size-option": _vm.pagination.pageSizeOptions,
                },
                on: {
                  "on-page-number-change": _vm.pageNumberChange,
                  "on-page-size-change": _vm.pageSizeChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("ve-table", {
            attrs: {
              columns: _vm.cols,
              "table-data": _vm.allContacts,
              "row-style-option": _vm.rowStyleOption,
              "border-x": true,
              "border-y": true,
              "row-key-field-name": "_id",
              id: "visitor-table",
              "fixed-header": true,
              "checkbox-option": _vm.checkboxOption,
              "clipboard-option": _vm.clipboardOption,
            },
          }),
          _vm._v(" "),
          _vm.forbidden
            ? _c("NoMessage", {
                attrs: {
                  title: "Forbidden Channel",
                  desc: "You are not allowed to see this channel",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.transferModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Transfer Contacts",
                "show-footer": false,
                "class-name": "transfer-contact-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.transferModalVisible = false
                },
              },
            },
            [
              _c("TransferContacts", {
                attrs: {
                  "channel-id": _vm.channelId,
                  "target-channel-id": _vm.targetChannelId,
                  "filter-types": ["messenger"],
                },
                on: {
                  "update:targetChannelId": function ($event) {
                    _vm.targetChannelId = $event
                  },
                  "update:target-channel-id": function ($event) {
                    _vm.targetChannelId = $event
                  },
                  transfer: _vm.handleTransfer,
                  cancel: function ($event) {
                    _vm.transferModalVisible = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }